import { Helmet } from "react-helmet-async";
 
const SITE_URL = "https://midcreatives.com";
const SITE_NAME = "Midcreatives";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
 
// Organization schema — tells Google and AI assistants who Midcreatives is.
// Rendered once, on the homepage only (pass organization={true} there).
const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Midcreatives",
  url: SITE_URL,
  logo: `${SITE_URL}/og-image.jpg`,
  description:
    "Midcreatives is a global creative design company. With one annual membership, brands get access to world-class creative talent, global design leaders, and a private network of the fastest-scaling companies in the world.",
  sameAs: [
    "https://www.linkedin.com/company/midcreatives",
  ],
};
 
/**
 * Drop <Seo /> inside any page component to give that page its own
 * title, description, canonical URL, and social-share tags.
 *
 * Usage:
 *   <Seo
 *     title="Membership | Midcreatives"
 *     description="One annual membership. Everything included."
 *     path="/membership"
 *   />
 */
export default function Seo({
  title,
  description,
  path = "/",
  type = "website",
  image = DEFAULT_OG_IMAGE,
  organization = false,
  schema = null,
}) {
  const url = `${SITE_URL}${path}`;
 
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
 
      {/* Open Graph (LinkedIn, Facebook, WhatsApp previews) */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
 
      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
 
      {/* Structured data */}
      {organization && (
        <script type="application/ld+json">
          {JSON.stringify(ORGANIZATION_SCHEMA)}
        </script>
      )}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
